module.exports = __webpack_public_path__ + "static/media/thecountrystore-logo-leaf.0570ede6.jpg";